import React, {memo} from "react";
import Script from "next/script";
import {getBuildId} from "@/utils/communUtil";


const Scripts = memo((props) => {
    return (
        <>
            <Script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.1.1/jquery.min.js "
                    strategy="beforeInteractive"/>
            <Script src="https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.js"
                    strategy="beforeInteractive"/>
            <Script src="https://cdn.polyfill.io/v3/polyfill.min.js"
                    strategy="beforeInteractive"/>
            <Script src={"/assets/js/wording-manager.js?v="+getBuildId()} strategy="beforeInteractive"/>
            <Script src={"/assets/js/actionTrigger.min.js?v="+getBuildId()} strategy="beforeInteractive"/>
            <Script src={"/assets/js/runDeferTag.min.js?v="+getBuildId()} strategy="beforeInteractive"/>
            <Script src="/assets/js/jquery.fancybox.js" strategy="beforeInteractive"/>
            <Script src={"/assets/js/Default/consentCookiesManager.js?v="+getBuildId()} strategy="beforeInteractive"/>
            <Script src={"/assets/js/Default/jquery.dqe.js?v="+getBuildId()} strategy="beforeInteractive"/>
            <Script src="/assets/js/owl.carousel.min.js" strategy="beforeInteractive"/>
            {props.children}
        </>
    )


})
export default Scripts